import { Fragment } from 'react';

import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import { MultiSelect } from '@components/common';
import { DropDownFilterButtonSize } from '@components/common/DropDownFilter/DropDownFilter';
import { FormLabelStyled } from '@components/common/FormStyled/FormStyled';
import { LabelMarkStyled } from '@components/common/Input/styled/InputStyled';
import { IMultiSelectProps } from '@components/common/MultiSelect/MultiSelect';
import { IOptionItemProps } from '@components/common/Select/Select';

import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import FormField, { IFormFieldProps } from './FormField';

type TFormFieldMultiSelect = IFormFieldProps &
    Partial<Pick<IMultiSelectProps, 'options' | 'placeholder' | 'selectedOptions' | 'onSelect'>>;

const FormFieldMultiSelect = (props: TFormFieldMultiSelect) => {
    const translationCommon = useSelector(makeSelectTranslationCommon());

    const { setFieldTouched, setFieldValue, validateField } = useFormikContext();

    return (
        <FormField {...props}>
            {({ field, label, required }) => {
                const onSelectHandler = (value: IOptionItemProps[]) => {
                    props.onSelect?.(value);
                    setFieldValue(field.name, value);
                    setTimeout(() => {
                        validateField(field.name);
                    });
                };

                return (
                    <Fragment>
                        {label && (
                            <FormLabelStyled>
                                {label}
                                {required && <LabelMarkStyled>*</LabelMarkStyled>}
                            </FormLabelStyled>
                        )}
                        <MultiSelect
                            filterButtonSize={DropDownFilterButtonSize.medium}
                            isSuggest={false}
                            options={props.options || []}
                            placeholder={props.placeholder}
                            selectedOptions={field.value || []}
                            translation={translationCommon}
                            onClose={() => setFieldTouched(field.name)}
                            onSelect={onSelectHandler}
                        />
                    </Fragment>
                );
            }}
        </FormField>
    );
};

export default FormFieldMultiSelect;
